// @react/hooks/useUserprofileAvatar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { userprofileAvatarStore } from '@core/stores';

/**
 * React hook for Avatar operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useUserprofileAvatar } from '@react/hooks';
 *
 * const AvatarList = observer(() => {
 *   const store = useUserprofileAvatar();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useUserprofileAvatar() {
  return userprofileAvatarStore;
}
